import AppImage from '@theme/components/atom/AppImage'
import MenuItemMixin from '~/mixins/MenuItemMixin'
import Pill from '@theme/components/atom/Pill'
import VerticalMenuItem from '~/themes/base/components/shop/VerticalMenuItem'

export default {
  components: { AppImage, Pill },
  extends: VerticalMenuItem,
  mixins: [MenuItemMixin],
  props: {
    collapsible: Boolean,
    groupedSubmenuItem: Boolean,
  },
  computed: {
    hasChildren() {
      return Boolean(this.link.children && this.link.children.length)
    },
    toggleIcon() {
      return this.showSubcategories ? require('@icon/minus.svg?raw') : require('@icon/plus.svg?raw')
    },
  },
}
